var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "51px",
    viewBox: "0 0 35 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.9676773,0 C7.59669146,0 0,7.81615068 0,17.457853 L0,17.457853 C0,27.0995553 7.59669146,34.915706 16.9676773,34.915706 L16.9676773,34.915706 C18.3722154,34.915706 19.737126,34.7400484 21.0425955,34.408966 L21.0425955,34.408966 C24.4556169,38.7619333 32.2315255,39.2275946 32.2315255,39.2275946 L32.2315255,39.2275946 C32.2315255,39.2275946 26.8831675,35.4178477 27.6374289,31.032845 L27.6374289,31.032845 C31.4793498,27.8322284 33.9353547,22.9401792 33.9353547,17.457853 L33.9353547,17.457853 C33.9353547,7.81615068 26.3386632,0 16.9676773,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flow-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Owner--Activate-Copy",
    transform: "translate(-758, -923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(311, 894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(47, 28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(400.2124, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0, 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9676773,1.54481082 C7.59669146,1.54481082 0,9.3609615 0,19.0026638 L0,19.0026638 C0,28.6443661 7.59669146,36.4605168 16.9676773,36.4605168 L16.9676773,36.4605168 C18.3722154,36.4605168 19.737126,36.2848592 21.0425955,35.9537768 L21.0425955,35.9537768 C24.4556169,40.3067441 32.2315255,40.7724054 32.2315255,40.7724054 L32.2315255,40.7724054 C32.2315255,40.7724054 26.8831675,36.9626585 27.6374289,32.5776559 L27.6374289,32.5776559 C31.4793498,29.3770393 33.9353547,24.4849901 33.9353547,19.0026638 L33.9353547,19.0026638 C33.9353547,9.3609615 26.3386632,1.54481082 16.9676773,1.54481082 Z",
    id: "Fill-1",
    fill: "#000000",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "twitter-x-seeklogo-3",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.7876, 9)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0462325894,0 L7.38190972,9.92802969 L0,18 L1.66150361,18 L8.12450076,10.9327094 L13.3462326,18 L19,18 L11.251418,7.51363563 L18.1225373,0 L16.4610337,0 L10.5091458,6.50863321 L5.7,0 L0.0462325894,0 Z M2,1 L4.58497665,1 L16,17 L13.4150233,17 L2,1 Z",
    id: "path1009",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXTwitter);
export default __webpack_public_path__ + "static/media/x-twitter.2f59db1a65476dbd5f2d0acfeec0d747.svg";
export { ForwardRef as ReactComponent };